exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".ZkPRT4ejlLCSEPE0yx2KK{border-bottom:.07143rem solid #ccc;padding:.71429rem 1.42857rem}.tZdXLGu6B5GqKPycn_lTo{display:-webkit-inline-box;display:-webkit-inline-flex;display:-moz-inline-box;display:-ms-inline-flexbox;display:inline-flex;font-size:1.125em;font-weight:600;margin-right:1.42857rem}._13i9CSXbnkF9AsqOic_P3l{font-style:italic;padding:.71429rem 1.42857rem 1.42857rem}.AkwN0RrqSBQOqDHxEVj5A{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;padding:.71429rem 0 2.14286rem}._3r1IPix_8OkRBwFJVCEqK1{margin-right:.35714rem}.Rm7AtlyGawjkGbwXDQGTF{-webkit-box-pack:end;-webkit-justify-content:flex-end;-moz-box-pack:end;-ms-flex-pack:end;justify-content:flex-end}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"RejectNotePopup_title": "ZkPRT4ejlLCSEPE0yx2KK",
	"RejectNotePopup_title_text": "tZdXLGu6B5GqKPycn_lTo",
	"RejectNotePopup_content": "_13i9CSXbnkF9AsqOic_P3l",
	"RejectNotePopup_content_info": "AkwN0RrqSBQOqDHxEVj5A",
	"RejectNotePopup_content_info_icon": "_3r1IPix_8OkRBwFJVCEqK1",
	"RejectNotePopup_buttons": "Rm7AtlyGawjkGbwXDQGTF"
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader?{"root":".","modules":true,"import":false,"importLoaders":1}!../node_modules/postcss-loader/lib?{"config":{"path":"/var/lib/jenkins/workspace/_omni-operation-ui_release_2.7.3/node_modules/omni-common-ui/postcss.config.js"}}!./components/RejectNotePopup/style.postcss
// module id = 1484
// module chunks = 0